/* eslint-disable react/no-array-index-key */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-string-refs */
import React, { Component } from 'react';
import Slider from 'react-slick';
import { Waypoint } from 'react-waypoint';
import CardSlide from './Slide';
import Img from '../../Img';

import styles from './featuredCardSlider.module.scss';

class FeaturedCardSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            autoplay: false,
        };
        this.handleMoveForward = this.handleMoveForward.bind(this);
        this.handleMoveBack = this.handleMoveBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOnEnter = this.handleOnEnter.bind(this);
    }

    componentDidMount() {
        this.setState({ showSlider: true });
    }

    handleMoveForward() {
        this.slider.slickNext();
    }

    handleMoveBack() {
        this.slider.slickPrev();
    }

    handleChange(currentSlide) {
        this.setState({ currentIndex: currentSlide });
    }

    handleOnEnter() {
        this.setState({ autoplay: true });
        this.forceUpdate();
    }

    render() {
        const responsive = [{ breakpoint: 1240, settings: { slidesToShow: 1 } }];
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive,
            arrows: false,
            autoplay: this.state.autoplay,
            afterChange: this.handleChange,
            initialSlide: 0,
            autoplaySpeed: 6000,
        };
        return (
            <div className={styles.section}>
                <div className="container">
                    <div className="row">
                        <div className="col p0">
                            {/* <div className="hp-spacing"> */}
                            {this.state.showSlider && (
                                <Slider {...settings} ref={c => this.slider = c}>
                                    {this.props.featuredCards && this.props.featuredCards.map((featuredCard, i) => {
                                        if (featuredCard.is_active) {
                                            return (
                                                <CardSlide
                                                    key={`cardslide-${i}`}
                                                    index={i}
                                                    currentIndex={this.state.currentIndex}
                                                    title={featuredCard.title}
                                                    copy={featuredCard.description}
                                                    image={featuredCard.featuredcardimage}
                                                    url={featuredCard.image_url}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                                </Slider>
                            )}
                            <Waypoint onEnter={this.handleOnEnter} />
                            <button
                                type="button"
                                className={styles.backBtn}
                                ref="back"
                                onClick={this.handleMoveBack}
                            >
                                <Img src="/img/left-arrow.svg" />
                            </button>
                            <button
                                type="button"
                                className={styles.nextBtn}
                                ref="next"
                                onClick={this.handleMoveForward}
                            >
                                <Img src="/img/right-arrow.svg" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FeaturedCardSlider;
